export type StateWithoutExclusionList = {
  stateCode: string;
  stateName: string;
  /** Official document showing the state directs providers to federal lists. */
  evidenceUrl: string;
};

/** Jurisdictions whose Medicaid agency publishes no exclusion or termination
 * list of its own. Each directs providers to the federal HHS-OIG LEIE (and
 * usually SAM), which every verification run screens, so reports list them
 * beside the state checks instead of creating checks with nothing to collect.
 * Evidence and review dates: docs/state-medicaid-exclusions-rollout.md. */
export const STATES_WITHOUT_EXCLUSION_LIST: readonly StateWithoutExclusionList[] =
  [
    {
      stateCode: "VA",
      stateName: "Virginia",
      evidenceUrl:
        "https://vamedicaid.dmas.virginia.gov/sites/default/files/2025-07/Hospital%20-%20Chapter%202%20%28updated%207.17.25%29_Final.pdf",
    },
    {
      stateCode: "WI",
      stateName: "Wisconsin",
      evidenceUrl: "https://www.dhs.wisconsin.gov/publications/p02877.pdf",
    },
    {
      stateCode: "OK",
      stateName: "Oklahoma",
      evidenceUrl:
        "https://oklahoma.gov/ohca/providers/provider-enrollment.html",
    },
    {
      stateCode: "UT",
      stateName: "Utah",
      evidenceUrl:
        "https://medicaid-documents.dhhs.utah.gov/Documents%2Fmanuals%2Fpdfs%2FMedicaid+Provider+Manuals%2FAll+Providers+General+Information+Section+I%2FAllProvidersGeneralInfo_Section_1.pdf",
    },
    {
      stateCode: "NM",
      stateName: "New Mexico",
      evidenceUrl:
        "https://www.hca.nm.gov/wp-content/uploads/FileLinks/5cc5015adb6243f1b88a7e8b2e7a1cac/AppendixB1_MAD335.pdf",
    },
    {
      stateCode: "RI",
      stateName: "Rhode Island",
      evidenceUrl:
        "https://eohhs.ri.gov/sites/g/files/xkgbur226/files/2021-03/exclusion_letter.pdf",
    },
    {
      stateCode: "SD",
      stateName: "South Dakota",
      evidenceUrl: "https://dss.sd.gov/medicaid/generalinfo/faq.aspx",
    },
    {
      stateCode: "DC",
      stateName: "District of Columbia",
      evidenceUrl:
        "https://dhcf.dc.gov/sites/default/files/dc/sites/dhcf/page_content/attachments/MCP%20Contract%20PUBLIC.pdf",
    },
  ];
